import React, {useMemo} from 'react';
import {CodeListsGate} from 'services/codelists';
import {useAllCodeListIds} from 'services/codelists/hooks/useAllCodeListIds';
import {ThesaurusesGate} from 'services/thesaurus';
import {useAllThesaurusIds} from 'services/thesaurus/hooks/useAllThesaurusIds';
import {
  SceneExtensionsContext,
  useLinkedValueSearchSceneExtensionCore,
  useSceneExtensionsContextProviderValue,
} from 'sceneExtensions';
import {PrizeEditSceneCore} from './PrizeEditSceneCore';

export const PrizeEditScene: React.FC = () => {
  const codelistIds = useAllCodeListIds();
  const thesaurusIds = useAllThesaurusIds();

  const linkedValueSearchExtension = useLinkedValueSearchSceneExtensionCore({
    canToggleFullWidth: true,
  });
  const extensions = useMemo(
    () => [linkedValueSearchExtension],
    [linkedValueSearchExtension],
  );

  const sceneExtensionContext =
    useSceneExtensionsContextProviderValue(extensions);

  return (
    <ThesaurusesGate thesauruses={thesaurusIds}>
      <CodeListsGate codeLists={codelistIds}>
        <SceneExtensionsContext.Provider value={sceneExtensionContext}>
          <PrizeEditSceneCore />
        </SceneExtensionsContext.Provider>
      </CodeListsGate>
    </ThesaurusesGate>
  );
};
